import { LocalizationProvider } from '@mui/lab';
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { Box, Button, Card, Fab, Grid, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import AddIcon from "@mui/icons-material/Add";
import api from '../../../components/services/api'
export default function Stock() {
  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 10,
    left: "auto",
    position: "fixed",
  };
  const [data, setData] = useState([])
  const getData = async () => {
    try {
      const data = await api.get("api/stock/list");
      setData(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getData()
  },[])
  const columns = [
    { field: "LinersName", headerName: "Ship Agent", width: 250 },
    { field: "Import", headerName: "Import Container", width: 200 },
    { field: "Used", headerName: "Used Container", width: 200 },
    { field: "Balance", headerName: "Balance Container", width: 200 },
    {
      field: "Action",
      width: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Link
              to={{
                pathname: `/Planner/ViewStock/${params.id}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
              >
                View
              </Button>
            </Link>
          </>
        );
      },
    },
  ];
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
          <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ตู้คอนเทนเนอร์
          </h6>

          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Stock Container
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex", flexDirection: "row" }}>
              <Typography className="textcolorBule">Planner</Typography>
              <Typography>
                <span>&nbsp;</span> / Stock
              </Typography>
            </Grid>
          </Grid>
        
          <Box
            sx={{
              height: 630,
              width: "100%",
              marginTop: "10px",
              "& .Active": {
                color: "#28A745",
              },
              "& .Inactive": {
                color: "#F53C56",
              },
            }}
          >
            <DataGrid
              getRowId={(r) => r.LinersId}
              rows={data}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10]}
              hideFooterSelectedRowCount
              disableColumnFilter
              disableColumnMenu
              getCellClassName={(params) => {
                if (params.field === "Status") {
                  return params.value == 1 ? "Active" : "Inactive";
                }
              }}
             
            />
          </Box>
          <Link to="/Planner/AddContainerList">
          <Fab color="primary" style={floating_action_style} aria-label="add">
            <AddIcon />
          </Fab>
        </Link>
        </Card>
      </LocalizationProvider>
    </div>
  )
}
